import { Component, OnInit, Inject,OnDestroy, ViewEncapsulation } from '@angular/core';
import { StaffService } from '../../staff.service';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { StaffGroupForCreationResponse,StaffEditGroupForCreation} from '../../staff';
import { ApiService } from '../../../../api.service';
import { GroupNamefoundResponse, checkGroupName, checkGroupNotifyLevel } from '../../../../api';
import { appsettings } from '../../../../app-settings';
import { RollbarService } from '../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck,generateAlertMessage,AuthFailedMessage } from '../../../../app-general';
import { enumGroup_Type } from '../../../../app-settings';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { HostListener } from "@angular/core";
@Component({
  selector: 'app-edit-staff-group',
  templateUrl: './edit-staff-group.component.html',
  providers: [ StaffService ],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-staff-group.component.scss']
})
export class EditStaffGroupComponent implements OnInit,OnDestroy {

  public staffGroupEditCreationForm : FormGroup;
  watcher: Subscription;
  columns: number = 3;
  EditGroupId;
  oldgroupname;
  staffeditgroupbool : boolean = true;
  private _onDestroy: Subject<void> = new Subject<void>();
  grouprowHeight = "67px";
  SiteId = "1";
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditStaffGroupComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  @Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService,
  private staffService: StaffService,public dialog: MatDialog) {
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 3;
        }         
        else {
          this.columns = 3;
        }
      }
    });
        this.EditGroupId = data.GroupId;
        this.oldgroupname = data.Groupname;
  }

  ngOnInit() {
    this.onResize();
      this.staffGroupEditCreationForm = new FormGroup({
        groupname: new FormControl('',[Validators.required, Validators.maxLength(30), Validators.pattern(appsettings.Name_Pattern)]),
        description:new FormControl('',[Validators.required, Validators.maxLength(150), Validators.pattern(appsettings.Name_Pattern)])
      });
  }
  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.staffGroupEditCreationForm.controls).forEach(field => { // {1}
        const control = this.staffGroupEditCreationForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('edit-staff-group.component.ts' + ' - handleInput() - ' + err.message);
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {    
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)         
     if(isIEOrEdge == true)
     {       
       this.grouprowHeight = "72.5px";
     }     
  }
  public onCloseCancel = () => {   
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }
  public hasError = (controlName: string, errorName: string) =>{
    return this.staffGroupEditCreationForm.controls[controlName].hasError(errorName);
  }
  public createStaffGroup = (StaffgroupFormValue) => {    
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.staffGroupEditCreationForm.valid && this.staffeditgroupbool) {          
        this.staffeditgroupbool = false;
      var groupnamefoundItem : checkGroupName = 
      {
        siteId:this.SiteId, 
        authKey: localStorage.getItem("Authkey"),
        groupType: 2, 
        newGroupName: StaffgroupFormValue.groupname.toString(), 
        groupId: parseInt(this.EditGroupId) 
      }
        this.apiService.checkGroupName(groupnamefoundItem).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse : GroupNamefoundResponse[])=>{        
          if(apiresponse.toString() == "not found")
          {                        
            this.checkGroupNotificationlevel(StaffgroupFormValue)
          }
          else
          {
            this.staffeditgroupbool = true;
            generateAlertMessage(this.dialog, "Staff Group name '" + apiresponse[0].name + "' already exists");
            return;
          }
        });             
      }
    }
    catch (err) {
      throw new Error('edit-staff-group.component.ts' + ' - createStaffGroup() - ' + err.message);
    }    
  }
  
  checkGroupNotificationlevel(StaffgroupFormValue)
  {
    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
          return;
      }      
      if(this.oldgroupname != StaffgroupFormValue.groupname.replace(/\s+/g, ' ').trim())
      {
        var groupfoundItem : checkGroupNotifyLevel = 
        {
          siteId:this.SiteId, 
          authKey: localStorage.getItem("Authkey"),
          resStaffType:  parseInt(enumGroup_Type.Staff.toString()), 
          resStaffGroupId: this.EditGroupId.toString() 
        }
          this.apiService.checkGroupNotificationlevel(groupfoundItem).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : any[])=>{              
            if(apiresponse.length == 0)
            {
              this.updateStaffGroup(StaffgroupFormValue);
            }
            else
            {
              this.staffeditgroupbool = true;
              generateAlertMessage(this.dialog, "Staff Group name '" + apiresponse[0].GroupName + "' is in escalation level,so please remove this group from escalation and try again.");
              return;
            }
        })
      }
      else
      {
        this.updateStaffGroup(StaffgroupFormValue);
      }
    }
    catch (err) {
      throw new Error('edit-staff-group.component.ts' + ' - checkGroupNotificationlevel() - ' + err.message);
    }  
  }
  
  // edit Staff Group
  private updateStaffGroup = (StaffgroupFormValue) => {
    try
    {
        let EditResidentgroup: StaffEditGroupForCreation = {             
            authKey : localStorage.getItem("Authkey"),         
            groupname : StaffgroupFormValue.groupname.replace(/\s+/g, ' ').trim(),
            description: StaffgroupFormValue.description.replace(/\s+/g, ' ').trim(),
            groupId:  this.EditGroupId.toString()
        }
        this.staffService.updateStaffGroup(EditResidentgroup).pipe(takeUntil(this._onDestroy))
          .subscribe((apiresponse : StaffGroupForCreationResponse[])=>{                
            if(apiresponse["apiReturn"] == "Success")
            { 	
              this.staffeditgroupbool = false;
              generateAlertMessage(this.dialog, 'Staff group edited successfully.')             
            }
            else if(apiresponse["apiReturn"] == "Fail")
            {
              this.staffeditgroupbool = true;
              generateAlertMessage(this.dialog, 'Staff group edited failed.')             
            }
            else if(apiresponse["apiReturn"] == "Invalid Auth Key")
            {  
                this.thisDialogRef.close('close');                 
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            } 
            this.thisDialogRef.close('Confirm');  
        });      
        
    }
    catch (err) {
      throw new Error('edit-staff-group.component.ts' + ' - updateStaffGroup() - ' + err.message);
    }     
  }
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
